import {useSelector} from 'react-redux';

import {Video} from '@stencil/gi-video/src';

import HappyPlayIcon from '@stencil/icons/src/HappyPlayIcon/HappyPlayIcon';
import {showVideoDwebSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

import * as S from '../CaptivativeImagesGrid.styles';

const CaptivateLandscapeImage = ({
  dataList = [],
  isFullView = false,
  updateCarouselState = imageNo => {},
}) => {
  const showDwebVideos = useSelector(showVideoDwebSelector);

  if (!dataList.length || dataList.length !== 1) return null;
  const item = dataList[0];

  if (showDwebVideos && item.mediaType === 'VIDEO') {
    return isFullView && item.url ? (
      <Video
        videoUrl={item.url}
        isAutoPlay={item.isAutoPlay || false}
        key={`${item?.mediaType}-${item?.roomCode || ''}-${item.imageNo}-0`}
      />
    ) : (
      <S.VideoLandscapeImageWrapper
        onClick={() => updateCarouselState({imageNo: item.imageNo, isOpen: true})}
      >
        <S.CaptivateLandscapeImage
          src={item.thumbnailURL}
          key={`${item?.mediaType}-${item?.roomCode || ''}-${item.imageNo}-0`}
        />
        <HappyPlayIcon />
      </S.VideoLandscapeImageWrapper>
    );
  }

  return (
    <S.CaptivateLandscapeImage
      src={item.url}
      onClick={() => updateCarouselState({imageNo: item.imageNo, isOpen: true})}
    />
  );
};

export default CaptivateLandscapeImage;
